/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';

import { css } from '@emotion/css';
import { observer } from 'mobx-react-lite';

import { PreTagForDebugging } from '^/commonComponents/ui/PreTagForDebugging';
import { ReservationDetailed } from '^/types/ReservationDetailed/RawReservationDetailed';

import { ReservationDetailsBillPODBooked } from './ReservationDetailDesktop.bill.pod.booked';
import { ReservationDetailsBillPODCancelled } from './ReservationDetailDesktop.bill.pod.cancelled';
import { ReservationDetailsBillPPDBooked } from './ReservationDetailDesktop.bill.ppd.booked';
import { ReservationDetailsBillPPDCancelled } from './ReservationDetailDesktop.bill.ppd.cancelled';
import { ExtraChargeDisplayCurrency } from '../../extraChargeDisplay';

export const ReservationDetailsBill: React.FC<{
  data: ReservationDetailed;
  onClickCancelReservation(reservationToCancel: ReservationDetailed): void;
  extraChargeDisplayCurrency?: ExtraChargeDisplayCurrency;
}> = observer(function ReservationDetailsBill({
  data,
  onClickCancelReservation,
  extraChargeDisplayCurrency = 'foreign',
}) {
  if (data.pay_type === 'POD') {
    if (data.res_status === 'booked') {
      return (
        <ReservationDetailsBillPODBooked
          data={data}
          onClickCancelReservation={onClickCancelReservation}
          extraChargeDisplayCurrency={extraChargeDisplayCurrency}
        />
      );
    }
    return (
      <ReservationDetailsBillPODCancelled
        data={data}
        extraChargeDisplayCurrency={extraChargeDisplayCurrency}
      />
    );
  }
  if (data.res_status === 'booked') {
    return (
      <ReservationDetailsBillPPDBooked
        data={data}
        onClickCancelReservation={onClickCancelReservation}
        extraChargeDisplayCurrency={extraChargeDisplayCurrency}
      />
    );
  }
  return (
    <ReservationDetailsBillPPDCancelled
      data={data}
      extraChargeDisplayCurrency={extraChargeDisplayCurrency}
    />
  );
});
